document.addEventListener('DOMContentLoaded', function() {
    const metafieldContent = document.querySelector('#tab_3RJWwh .product-single__accordion__item-wrap.rte');

    if (metafieldContent) {
        const totalElements = metafieldContent.children.length;

        if (totalElements > 11) {
            const showMoreCOALink = document.querySelector('.show-more-COA');

            if (showMoreCOALink) {
                showMoreCOALink.classList.remove('--hide');
            }
        }
    }

    const metafieldCOALinks = document.querySelectorAll('#tab_3RJWwh .product-single__accordion__item-wrap.rte a');
    const metafieldSOPSDSLinks = document.querySelectorAll('#tab_9RbR98 .product-single__accordion__item-wrap.rte a');
    metafieldCOALinks.forEach(link => link.setAttribute('target', '_blank'));
    metafieldSOPSDSLinks.forEach(link => link.setAttribute('target', '_blank'));
});